import { CommonExport } from '../common/common-export.service';
import { setLastExportId } from 'modules/export/storage/last-export.storage';

export class ClientExportService extends CommonExport<any> {
  _getExportPath = async (params: any, path?: string) => {
    const response = await this.getExportPath(path ?? '/users/customers/export', params);
    if (response?._id) {
      setLastExportId(response._id);
    }
    return response;
  };
}

export default new ClientExportService('/ms-auth/api');
